import { gql, type TypedDocumentNode, useQuery } from '@apollo/client';
import type { InventoryPreferencesQuery, InventoryPreferencesQueryVariables } from 'types/graphql';

export const INVENTORY_PREFERENCES_QUERY: TypedDocumentNode<
  InventoryPreferencesQuery,
  InventoryPreferencesQueryVariables
> = gql`
  query InventoryPreferencesQuery {
    organization {
      id
      gs1CompanyPrefix
    }
    orgSettings {
      id
      unitRounding
    }
  }
`;

/** The Preferences section's own read; the app-wide settings read usually answers it from the cache. */
export function useInventoryPreferences() {
  const { data, error, refetch } = useQuery(INVENTORY_PREFERENCES_QUERY, { fetchPolicy: 'cache-first' });

  return { preferences: data, error, refetch };
}
